import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28.5 17.894c0-2.942-.872-5.768-2.617-8.476-1.745-2.709-4.14-5.078-7.188-7.11-.573-.39-1.165-.41-1.777-.058-.612.351-.918.879-.918 1.582v2.031c0 .885-.306 1.628-.918 2.227-.612.599-1.36.898-2.246.898a2.88 2.88 0 0 1-1.27-.293 3.306 3.306 0 0 1-1.074-.84 1.33 1.33 0 0 0-.8-.488 1.128 1.128 0 0 0-.919.215 12.41 12.41 0 0 0-3.867 4.492 12.549 12.549 0 0 0-1.406 5.82c0 2.292.56 4.382 1.68 6.27a12.907 12.907 0 0 0 2.555 3.113c.393.348.99-.194.824-.691a7.425 7.425 0 0 1-.371-2.363 7.5 7.5 0 0 1 .585-2.95 7.757 7.757 0 0 1 1.68-2.48l4.845-4.743a1 1 0 0 1 1.402.003l4.808 4.74a7.959 7.959 0 0 1 1.719 2.5c.39.911.585 1.888.585 2.93 0 .833-.123 1.62-.37 2.363-.166.497.43 1.039.823.692a12.908 12.908 0 0 0 2.555-3.114c1.12-1.888 1.68-3.978 1.68-6.27Zm-11.801.526a1 1 0 0 0-1.398 0l-2.621 2.56a4.714 4.714 0 0 0-1.016 1.485 4.415 4.415 0 0 0-.351 1.758c0 1.276.455 2.363 1.367 3.261.911.899 2.018 1.348 3.32 1.348s2.409-.45 3.32-1.348c.912-.898 1.367-1.986 1.367-3.262 0-.599-.117-1.178-.351-1.738a4.65 4.65 0 0 0-1.016-1.504l-2.62-2.56Z" stroke="none"></path>';
export var FireSVG = function FireSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FireSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FireSVG);